import { useMutation } from '@tanstack/react-query'

import { EncerrarAtendimentoService } from '@/http/encerrar-atendimento.service'
import { type TAtendimentoEncerradoResponse } from '@/http/encerrar-atendimento.service'
import type { AxiosErrorMap } from '@/infra/http'
import { atendimentoKeys } from '@/utils/atendimento-query-keys'

export const useEncerrarAtendimento = () => {
  return useMutation<TAtendimentoEncerradoResponse, AxiosErrorMap, string>({
    mutationKey: atendimentoKeys.encerrarAtendimento(),
    mutationFn: async (id: string) => new EncerrarAtendimentoService().execute(id),
  })
}
